<template>
  <div>
    <v-select
      v-model="parentModel"
      variant="outlined"
      persistentPlaceholder
      density="compact"
      hideDetails
      :disabled="disabled"
      :items="parentItems"
      itemTitle="text"
      placeholder="Select configuration"
      class="segment-builder--subtypes _subtypes min-w-44"
      height="32px"
      bgColor="#ffffff"
      :menuProps="{ maxHeight: 410, offsetY: true }"
      @update:modelValue="updateParent"
    />
    <div v-if="parentModel" class="segment-builder--item next-selection">
      <RfChevronIcon class="fill-beige-50 mx-1 my-auto h-6 w-6 rotate-180" />
      <div class="segment-create-section">
        <div class="segment-create-slider">
          <div class="segment-create-title">
            <div>{{ parent?.min ?? 0 }}-10 represents the normalized scale of actual value.</div>
          </div>
          <RfRangeSlider
            v-model="childModel"
            :max="10"
            :min="parent?.min ?? 0"
            :step="1"
            :disabled="disabled"
            :isNormalized="true"
            style="margin-left: 0px"
            @update:modelValue="updateFilter"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RfRangeSlider from "@/components/RfRangeSlider.vue";
import { UserFilterItems } from "@/utils/constants/SegmentsConstants";
import { isUserFilterDisabled } from "@/utils/segmentsHelpers";
import { useCustomFields } from "@/utils/composables/useCustomFields";
import RfChevronIcon from "../icons/RfChevronIcon.vue";

export default {
  name: "RfUser",
  components: { RfRangeSlider, RfChevronIcon },
  props: ["filter", "disabled"],
  setup: () => ({ customFields: useCustomFields() }),
  data: () => ({ parentModel: null, childModel: [0, 10] }),
  computed: {
    parent() {
      return this.parentItems.find(parent => parent.value === this.parentModel);
    },
    parentItems() {
      return Object.values(UserFilterItems).filter(
        item => isUserFilterDisabled(item.field, this.customFields.appSystemFields.value) !== true,
      );
    },
    user() {
      return this.filter.user;
    },
    userKey() {
      return Object.keys(this.user)[0];
    },
    values() {
      if (!this.parent) return [];

      return this.filter.user[this.parent.value];
    },
  },
  mounted() {
    this.prepareFilter();
  },
  methods: {
    updateParent() {
      this.childModel = [this.parent?.min ?? 0, 10];
      this.updateFilter();
    },
    updateChild() {
      this.updateFilter();
    },
    updateFilter() {
      const filter = { user: { [this.parentModel]: this.childModel } };

      this.$emit("update:model", filter);
    },
    prepareFilter() {
      this.parentModel = this.userKey || null;
      this.childModel = this.values;
    },
  },
};
</script>
